import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyInputModule } from '@vendasta/galaxy/input';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import baseTranslation from '../../assets/i18n/en_devel.json';
import { WEBLATE_COMPONENT_NAME } from '../constants';

import { CommonModule } from '@angular/common';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { IconComponent, UIKitModule } from '@vendasta/uikit';
import { AssignedSalespersonModule } from '../assigned-salesperson/assigned-salesperson.module';
import { FormatPhoneNumberPipe } from '../common/pipes/format-phone-number.pipe';
import { TrialBannerModule } from '../trial-banner/trial-banner.module';
import { HelpCaseCardComponent } from './help-case-card/help-case-card.component';
import { HelpCenterComponent } from './help-center.component';
import { HelpSearchCardComponent } from './help-search-card/help-search-card.component';
import { HelpSideDrawerContainerComponent } from './help-side-drawer/help-side-drawer-container/help-side-drawer-container.component';
import { HelpSideDrawerModule } from './help-side-drawer/help-side-drawer.module';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { InboxAiSupportBannerComponent } from '@galaxy/conversation/ui';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatExpansionModule,
    MatSidenavModule,
    MatDividerModule,
    GalaxyLoadingSpinnerModule,
    GalaxyBadgeModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    UIKitModule,
    HelpSideDrawerModule,
    AssignedSalespersonModule,
    GalaxyInputModule,
    TrialBannerModule,
    IconComponent,
    FormatPhoneNumberPipe,
    InboxAiSupportBannerComponent,
  ],
  exports: [HelpCenterComponent, HelpSideDrawerContainerComponent],
  declarations: [HelpCenterComponent, HelpCaseCardComponent, HelpSideDrawerContainerComponent, HelpSearchCardComponent],
  providers: [],
})
export class HelpCenterModule {}
